// contexts/UtmContext.js

import React, { createContext, useContext } from 'react'
import { useUtmParams } from '@/hooks/useUtmParams'

// Create the context.
const UtmContext = createContext(null)

/**
 * This is the Context Provider.
 * It will use our custom hook and make the UTM data available to all child components.
 */
export const UtmProvider = ({ children }) => {
  const { utmData } = useUtmParams()

  return <UtmContext.Provider value={{ utmData }}>{children}</UtmContext.Provider>
}

/**
 * Custom hook to easily consume the context data within any component.
 */
export const useUtm = () => {
  const context = useContext(UtmContext)
  if (context === undefined) {
    throw new Error('useUtm must be used within a UtmProvider')
  }
  return context
}
